export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.enterFullscreen': 'Enter fullscreen',
  'component.exitFullscreen': 'Exit fullscreen',
  'component.todo.title': 'Pending Tasks',
  'component.todo.soundOn': 'Voice alert on',
  'component.todo.soundOff': 'Voice alert off',
  'component.todo.pending': 'Pending',
  'component.todo.processing': 'Handle',
  'component.todo.withdrawAudit': 'Member Withdrawal',
  'component.todo.activityAudit': 'Activity Review',
  'component.todo.smsBalance': 'Low SMS Balance',
};
